import { ProtocolSettings } from "./ProtocolSettings";
import { CommandLineSettings } from "./CommandLineSettings";
import { ProtocolSettingsTypes } from "./ProtocolSettingsTypes";

export class TelnetSettings extends CommandLineSettings {

	constructor() {
		super();
		this.Port = this.DefaultPort;
	}

	public get SettingsType(): string {
		return ProtocolSettingsTypes.Telnet;
	}

	public get DefaultPort(): number {
		return 23;
	}

	public Copy(obj: ProtocolSettings): void {
		if (!(obj instanceof TelnetSettings))
			return;
		let other = (obj as TelnetSettings);

		super.Copy(obj);
	}

	public Clone(): ProtocolSettings {
		let clone = new TelnetSettings();
		clone.Copy(this);
		return clone;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof TelnetSettings))
			return false;
		let other: TelnetSettings = (obj as TelnetSettings);

		return true;
	}

	public Write(obj: any, context: any): void {
		obj.telnet = {};
		obj = obj.telnet;

		super.Write(obj, context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.telnet)
			throw new Error();
		obj = obj.telnet;

		super.Read(obj, context);
	}

}

